export class PerimeterEdge {
    constructor(edge) {
        /*Assert.assert(
          edge.CcwTriangle == null  || edge.CwTriangle == null ,
          'one of the edge triangles has to be null',
        )*/
        this.Edge = edge;
    }
}
//# sourceMappingURL=PerimeterEdge.js.map